if (!customElements.get('piecework-image-text')) {
  customElements.define(
    'piecework-image-text',
    class PieceworkImageText extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          slideshow: this.querySelector('.splide'),
          slideshowWrapper: this.querySelector('.slideshow-wrapper'),
          slides: this.querySelectorAll('li'),
          slideshowContainer: this.querySelector('.slideshow-container'),
          pagination: this.querySelectorAll('.pw-media-pagination div'),
          controls: {
            prev: this.querySelector('[data-prev]'),
            next: this.querySelector('[data-next]'),
          },
        };

        // console.log(this.elements.slides);

        if (this.elements.slides.length < 2) return false;

        if (this.elements.slides.length > 1) {
          this.resizeSlideshow();
          window.addEventListener('resize', this.resizeSlideshow.bind(this));

          this.slider = new Splide(this.elements.slideshow, {
            type: 'loop',
            arrows: false,
            pagination: false,
            perPage: 1,
            perMove: 1,
            speed: 600,
            padding: { right: '10vw' },
            breakpoints: {
              768: {
                perPage: 1,
                padding: { right: '20vw' },
              },
            },
          }).mount();

          this.elements.controls.prev.addEventListener('click', () => {
            this.slider.go('<');
          });
          this.elements.controls.next.addEventListener('click', () => {
            this.slider.go('>');
          });

          this.slider.on('move', () => {
            if (this.elements.pagination) {
              this.elements.pagination.forEach((page) => {
                const slide = parseInt(page.dataset.slide);
                if (this.slider.index === slide) {
                  page.classList.add('tw-bg-current');
                } else {
                  page.classList.remove('tw-bg-current');
                }
              });
            }
          });
        }
      }

      resizeSlideshow() {
        const box = this.elements.slideshowWrapper.getBoundingClientRect();
        this.elements.slideshowContainer.style.width = box.width + (window.innerWidth - (box.x + box.width)) + 'px';
      }
    }
  );
}
